/*
    Place all application routes here
*/
import { withApiPrefix } from 'lib/ajax';

export default {
    home: '/',
    aboutUs: '/about-us',
    onboarding: '/onboarding',
    forgotPassword: '/forgot-password',
    changePassword: '/change-password',
    setup: '/setup',
    choose: '/choose',
    onboardingSuccess: '/onboarding/success',
    register: '/register',
    contact: '/contact-us',
    login: '/login',
    logout: '/logout',
    systemMessage: '/sys/msg',
    dashboard: '/dashboard',
    dashboardFront: '/dashboard/front',
    bookList: '/dashboard/books',
    addBook: '/dashboard/books-add',
    editBook: '/dashboard/books-edit',
    activity: '/dashboard/activity',
    settings: '/dashboard/settings',
    users: '/dashboard/users',
    adobeDownloadInstructions: '/adobe-instructions',
    readiumDownloadInstructions: '/readium-instructions',
    previewDownloadInstructions: '/preview-download-instructions',
    plans: '/manage-plans',
    serverError: '/server-error',
    webMaintenance: '/under-maintenance',
    account: '/dashboard/manage-account',
    productPage: '/products',
    productSecureCheckout: '/product/checkout',
    productCheckoutSuccess: '/product/checkout-success',
    productDownloadInstructions: '/product/download-instructions',
    api: {
        register: withApiPrefix('/auth/register'),
        ebook: withApiPrefix('/book'),
        transaction: withApiPrefix('/transaction'),
        transactionMultiple: withApiPrefix('/transaction/multiple'),
        downloadsReportData: withApiPrefix('/download/report'),
        getStripePublicKey: '/cors/get/stripe/pk',
        handshake: '/cors/handshake',
        sendPasswordReset: '/cors/password/send/reset',
        logout: '/cors/logout',
        login: '/cors/login',
        manuallyLogin: '/cors/m/manulallogin',
        sendIntegrationServiceCustomerInquery: '/cors/send/integration/service/customer/inquery',
        updatePassword: '/cors/password/update',
        legacyUserUpdatePassword: '/cors/legacy/user/password/update',
        getDefaultDrmSettings: '/cors/get/default/settings',
        updateDefaultDrmSettings: '/cors/update/default/settings',
        getPaypalIntegrationSettings: '/cors/get/paypal/integration/settings',
        updatePaypalIntegrationSettings: '/cors/update/paypal/integration/settings',
        getUserDetails: '/cors/get/user/details',
        updateUserDetails: '/cors/update/user/details',
        simpleUpdateUserPassword: '/cors/update/user/password',
        fulFillmentDownloadLink: `${process.env.REACT_APP_API_URI}/fulfillment`,
        getAllUserCards: '/cors/subscription/get/user/cards',
        addNewCard: '/cors/subscription/add/card',
        updateCard: '/cors/subscription/update/card',
        removeCard: '/cors/subscription/remove/card',
        setPrimaryCard: '/cors/subscription/set/primary/card',
        invoiceHistoryList: '/cors/subscription/get/invoice/history/list',
        getAllPlans: '/cors/subscription/get/plans',
        subscriptionPayment: '/cors/subscription/payment',
        couponCheck: '/cors/subscription/coupon/check',
        cancelSubscription: '/cors/subscription/cancel',
        closeGetstarted: '/cors/close/getstarted',
        transCsvDownload: `${process.env.REACT_APP_API_URI}/csv/activity/download`,
        publicGetTransDetails: `/cors/get/trans/details`,
        doesEmailExist: '/cors/check/email',
        saveBrandDetails: 'cors/brand/save',
        getBrandDetails: 'cors/brand/get',
        getUserDownloadCredits: 'cors/get/user/download/credits',
        getTransFullfillmentData: 'cors/get/trans/fullfillment/data/',
        lcpLicenseStop: 'cors/lcp-stop-license',
        getBookProductDetails: 'cors/get/book/product/details',
        saveBookProductDetails: 'cors/save/book/product/details',
        deleteProductDetailsImage: 'cors/book/product/details/delete/image',
        getMerchantAccountDetails: 'cors/merchant/get/details',
        saveMerchantAccountDetails: 'cors/merchant/save/details',
        merchantChargePayment: 'cors/merchant/payment/charge',
        createStripeAccountPage: `${process.env.REACT_APP_API_URI}/merchant/create/stripe/account`,
        merchantContactUs: 'cors/merchant/contact-us',
        getMoreBooksByMerchant: 'cors/merchant/more/books',
        setMixpanelId: 'cors/set/mixpanel/id',
        getPreviewLinkOfFirstEbook: 'cors/book/product/preview/link',
        makeTransactionFromPaypalPayment: 'cors/merchant/paypal/payment',
        merchantStripeCheckout: 'cors/merchant/stripe/checkout'
    },
    outside: {
        stripeJs: 'https://js.stripe.com/v2/',
        egAPIDocs: 'https://www.editionguard.com/api-documentation/',
        egHelpPage: 'https://editionguard.com/learn/',
        createAdobeAccount: 'https://account.adobe.com/',
        adobeDigitalEditionsDownload: 'https://www.adobe.com/solutions/ebook/digital-editions/download.html',
        thoriumMac: 'https://www.edrlab.org/software/thorium-reader/github/macos',    
        thoriumWindows: 'https://bit.ly/thoriumreader-en',
        r2Ios: 'https://apps.apple.com/us/app/r2-reader/id1363963230',
        r2Android: 'https://play.google.com/store/apps/details?id=org.readium.r2reader',
        paypalButtonJsSdk: 'https://www.paypal.com/sdk/js'
    }
};
